import { IDriver } from './driver'
import { ILoad } from './loads'

export enum ShareViaType {
  sms = 'sms',
  email = 'email',
}

export interface IShare {
  id?: string
  lastSharedAt?: string | null // ‘2020-07-30T00:00:00.00Z’
  lastSharedVia?: ShareViaType[] | null
  shareableId: string
  shareableType: string
  sharedWithDriver: IDriver
  url: string
}

export interface IGetShipmentSharesResponse {
  shares: IShare[]
}

export interface ICreateShareRequest {
  sharedWithDriverId: string
}

export interface ICreateShareResponse {
  share: IShare
}

export interface IGetShipmentResponse {
  shipment: ILoad
}

export interface ISendShareRequest {
  shareSend: {
    message: string
    shareVia: ShareViaType[] | null
  }
}

export interface IShipmentStatusUpdate {
  currentStopSequence: number | null
  status: string
  timestamp: string
}

export interface IShipmentInOutUpdate {
  checkedInAt?: string
  checkedOutAt?: string
}

export interface IShipmentPodUpdate extends Pick<ILoad, 'allAttachments'> {}
